import { Stack, Typography } from "@mui/material";

export const GradingBlock = ({
  title,
  value,
  field,
  onChange,
}: {
  title: string;
  value: number | null;
  field: string;
  onChange: (grade: number | null, field: string) => void;
}) => {
  return (
    <Stack gap="12px">
      <Typography
        component="span"
        variant="subtitle1"
        color="custom.textDarkBlue"
        fontWeight={500}
      >
        {title}
      </Typography>

      <Stack flexDirection="row" gap="12px" alignItems="center">
        {[1, 2, 3, 4, 5].map((el) => (
          <Stack
            key={el}
            onClick={() => onChange(value === el ? null : el, field)}
            sx={{
              border: `1px solid ${el === value ? "#1C3C6C" : "#D9D9D9"}`,
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 0",
              maxWidth: "86px",
              width: "100%",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "20px",
              }}
            >
              {el}
            </span>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
